module.exports = __webpack_public_path__ + "img/facts_1961.d7919653.jpg";